/* globals ca */

import { Project } from 'ca-api-client';

export const project = {
    state: {
        projects: [],
        integrations: [],
    },
    mutations: {
        setProjects(state, projects) {
            state.projects = projects;
        },
        setProjectIntegrations(state, integrations) {
            state.integrations = integrations;
        },
    },
    getters: {
        getProjects(state) {
            return state.projects;
        },
        getProjectIntegrations(state) {
            return state.integrations;
        },
        hasIntegration: (state) => (integration) => {
            const found = state.integrations.filter((share) => share.name === integration && share.enabled);
            return found.length > 0;
        },
    },
    actions: {
        async fetchProjectIntegrations({ commit, dispatch }) {
            const project = await Project.$find(ca.project.uuid).catch((error) => {
                if (error.response.status === 404) {
                    dispatch('setGalleryErrorState', {
                        // TODO: move error text to localization once we choose library
                        error: true,
                        title: "We're sorry, but something went wrong.",
                        msg: 'Could not load project information. Please try again later, or contact <a class="alert-link" href="mailto:contact@spatialmedia.com.au">support</a> if error persists.',
                    });
                }
            });
            const integrations = project.integrations;
            commit('setProjectIntegrations', integrations);
            return project;
        },
    },
};
